export default __webpack_public_path__ + "static/media/ico-undo-black.a3037a11.svg";